import { useContext } from "react";
import ProjectsContext from "Services/ProjectsProvider";

const useProjects = () => {
    return useContext(ProjectsContext);
};

export default useProjects;
